import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-multi-brand-air-dryer',
  templateUrl: './multi-brand-air-dryer.component.html',
  styleUrls: ['./multi-brand-air-dryer.component.scss']
})
export class MultiBrandAirDryerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
